import { render, staticRenderFns } from "./ReturnCallSettings.vue?vue&type=template&id=95fcadb2&"
import script from "./ReturnCallSettings.vue?vue&type=script&lang=js&"
export * from "./ReturnCallSettings.vue?vue&type=script&lang=js&"
import style0 from "./ReturnCallSettings.vue?vue&type=style&index=0&id=95fcadb2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports